import React, { useState, useEffect } from 'react'
import api from '../components/api'
//import Accordion from 'react-bootstrap/Accordion';
import Residuos_DadosGestao from '../components/Residuos_DadosGestao'
import Residuos_DadosGeracao from '../components/Residuos_DadosGeracao'
import Residuos_DadosGeracaoConsolidado from '../components/Residuos_DadosGeracaoConsolidado'
import Residuos_Indicadores from '../components/Residuos_Indicadores'

import Correcoes from '../components/Correcoes'
import EmailCorrecoes from '../components/EmailCorrecoes'

import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import moment from 'moment'

const Modal = (props) => {

    
    var residuo_id = props.residuo_id
    var formulario_id = props.formulario_id
    var adesao_institucional_id = props.adesao_institucional_id
    var ano = props.ano
    
    const [totalCorrecoes, setTotalCorrecoes] = useState(0)
    const [totalEmails, setTotalEmails] = useState(0)

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()
    

    function validaResiduos(opc) {


        var dataPost = {

            opc: opc,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            formulario_id: formulario_id,

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma a ação?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)
                    

                    api.put(`residuosValida`, dataPost).then((result) => {
                        
                        //console.log(result.data)
                        if (result.data.alerta == 'ok') {

                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('Registro salvo com sucesso!')
                            window.$("#modalResiduos").modal('hide');
                            props.residuosSS()

                        } else {

                            window.toastr.error(result.data.alerta)
                            return false
                        }

                        
                    }).catch((err) => {
                        console.log(err.response)
                    })

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    async function geraPDF() {


        api.get(`residuosPDF/${adesao_institucional_id}/${ano}`).then((result) => {

            if (result.data.arquivo) {

                window.open(`${process.env.REACT_APP_API}/pdf/${result.data.arquivo}`)
                //window.open(`http://172.16.1.253:3700/pdf/${result.data.arquivo}`)

            } else {

                window.toastr.error(`Não foi possível gerar o PDF, provavelmente o preenchimento não está completo!`)
                return false

            }

        }).catch((err) => {

            console.log(err.response)

        })


    }





    const listaEmailsCorrecoes = () => {

        api.get(`emailsCorrecoesDesafio/${formulario_id}`).then((result) => {

            //console.log(result.data)
            setTotalEmails(result.data.length)

        }).catch((err) => {

            console.log(err.response)

        })

    }




    const verificaValidacoes = () => {

        //console.log('verificado')
        

        if (formulario_id) {

            var dataPost = {

                formulario_id: formulario_id,
                desafio: 'Resíduos',

            }

            console.log(dataPost)

            api.post('desafioValidaVarios', dataPost).then((result) => {

                if (result.data) {

                    setTotalCorrecoes(result.data.length)
                    
                }
                
              

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }

    useEffect(() => {

        verificaValidacoes()
        listaEmailsCorrecoes()

    }, [verificaDesafio, formulario_id])


    useEffect(() => {

        window.$('[href="#tabG1"]').tab('show');
        //console.log(adesao_institucional_id)

    }, [adesao_institucional_id, ano])
    

    return (

        <div>


                <div className="modal fade" id="modalResiduos" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document" style={{ width: '95%'}} >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Resíduos SS - Ano {ano} - {adesao_institucional_id}</h1>
                            </div>
                            <div class="modal-body">
                                    
                                    <div class="panel-body">


                                        <div class="row">
                                            
                                            <div class="col-sm-12">
                                                


                                                <ul class="nav nav-tabs">
                                                        <li class="active"><a href="#tabG1" data-toggle="tab">Dados gestão</a></li>
                                                        <li><a href="#tabG2" data-toggle="tab">Dados geração</a></li>
                                                        <li><a href="#tabG4" data-toggle="tab">Dados geração consolidado</a></li>
                                                        <li><a href="#tabG6" data-toggle="tab">Indicadores</a></li>
                                                        <li><a href="#tabG3" data-toggle="tab">Correções ({totalCorrecoes})</a></li>
                                                        <li><a href="#tabG5" data-toggle="tab">E-mails ({totalEmails})</a></li>
                                                </ul>

                                                <div class="tab-content">
                                                    <div class="tab-pane fade in active" id="tabG1">
                                                        <div class="panel-body">

                                                            <Residuos_DadosGestao adesao_institucional_id={adesao_institucional_id} formulario_id={formulario_id} ano={ano} residuosSS={props.residuosSS} />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabG2">
                                                        <div class="panel-body">

                                                            <Residuos_DadosGeracao adesao_institucional_id={adesao_institucional_id} formulario_id={formulario_id} residuo_id={residuo_id} ano={ano} residuosSS={props.residuosSS}/>

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabG3">
                                                        <div class="panel-body">

                                                            <Correcoes adesao_institucional_id={adesao_institucional_id} formulario_id={residuo_id} ano={ano}  origem="Resíduos" />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabG4">
                                                        <div class="panel-body">

                                                            <Residuos_DadosGeracaoConsolidado adesao_institucional_id={adesao_institucional_id} formulario_id={residuo_id} ano={ano}  origem="Resíduos" />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabG5">
                                                        <div class="panel-body">

                                                            <EmailCorrecoes adesao_institucional_id={adesao_institucional_id} formulario_id={residuo_id} ano={ano}  origem="Resíduos" />

                                                        </div>

                                                    </div>
                                                    <div class="tab-pane fade in" id="tabG6">
                                                        <div class="panel-body">

                                                            <Residuos_Indicadores adesao_institucional_id={adesao_institucional_id} formulario_id={residuo_id} ano={ano}  origem="Resíduos" />

                                                        </div>

                                                    </div>
                                                </div>

                                            </div>

                                        </div>




                                    </div>


                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger" onClick={() => geraPDF()}>PDF</button>

                                <button type="button" className="btn btn-info" onClick={() => validaResiduos('A')}>Em análise</button>
                                <button type="button" className="btn btn-danger" onClick={() => validaResiduos('P')}>Com pendências</button>
                                <button type="button" className="btn btn-primary" onClick={() => validaResiduos('V')}>Completo</button>
                                <button type="button" className="btn btn-warning" onClick={() => validaResiduos('Z')}>Verificado</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>

        </div>


    )



}


    

export default Modal